export default __webpack_public_path__ + "static/blob13-98b7615b9e15b51d0bab94f0c81eddeb.svg";